/**
 * 单选
 * @author yuxin.zhang 2018.11.9
 */

import React from 'react';

import { FormType } from '../FormType';

import ItemContext from './ItemContext';
import LeftTitle from './LeftTitle';

export default class ItemRadio extends ItemContext {
  constructor(props) {
    super(props);

    this.state = {
      errorMsg: '',
      dataError: false,
      value: '',
    };
  }

  UNSAFE_componentWillMount() {
    this.setValue(this.props.dataSource);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setValue(nextProps.dataSource);
    this.setError(nextProps.dataSource);
    this.cleanError(nextProps.dataSource);
    this.cleanValue(nextProps.dataSource);
  }

  /**
   * 下拉/单选框值变化监听
   * @param newValue 新的值所在的对象
   */
  onSelectChange = (newValue) => {
    const { key, onChange, errorData, formType, extend } =
      this.props.dataSource;
    const val = newValue ? newValue.value : '';
    const errorMsg = this.getErrorMsg(val, errorData);
    const allow = errorMsg.length === 0;
    this.setState({
      value: val,
      errorMsg,
      dataError: errorMsg && errorMsg.length !== 0,
    });
    onChange && onChange(key, formType, newValue, allow, extend);
  };

  /**
   * 渲染单选类型
   * @returns {*}
   */
  renderFormLineRadio() {
    const { errorMsg, value } = this.state;
    const { key, list, inputAttr, newLine, bottomArea } = this.props.dataSource;
    return (
      <div className="form-input-box">
        <div className="form-radio">
          {list.map((item, index) => {
            return (
              <label
                key={`${key}formRadio${index}`}
                htmlFor={`${key}formRadio${index}`}
                className={`form-label-radio${newLine ? ' block' : ''}`}
              >
                <input
                  type="radio"
                  className="check"
                  {...inputAttr}
                  id={`${key}formRadio${index}`}
                  checked={item.value === value}
                  onChange={() => {
                    this.onSelectChange(item);
                  }}
                />
                <label className="label" htmlFor={`${key}formRadio${index}`} />
                {item.label}
              </label>
            );
          })}
        </div>
        <br />
        {bottomArea}
        <span className="form-error-tips">{errorMsg}</span>
      </div>
    );
  }

  // 渲染下部提示
  renderTips(tips, isSpecial) {
    if (!tips || tips.length === 0) {
      return null;
    }
    return (
      <div className="tips-box">
        {tips.map((item, index) => {
          return (
            <div
              key={`tips${isSpecial ? 'Special' : ''}${index}`}
              className={`tips-item ${isSpecial ? 'especial' : ''}`}
            >
              {item}
            </div>
          );
        })}
      </div>
    );
  }

  render() {
    const { dataError, errorMsg } = this.state;
    const { dataSource } = this.props;
    const { bottomTips } = dataSource;
    const { isCategoryTop } = dataSource;

    const className = isCategoryTop ? 'form-item category-top' : 'form-item';
    // const className = 'form-item';
    return (
      <div
        className={className}
        data-error={dataError && errorMsg && errorMsg.length !== 0}
      >
        <LeftTitle dataSource={dataSource} />
        {this.renderFormLineRadio()}
        {this.renderTips(bottomTips)}
        {dataSource.rightArea}
      </div>
    );
  }
}

ItemRadio.defaultProps = {
  dataSource: {
    key: '',
    extend: null,
    placeholderRight: null,
    formType: FormType.RADIO,
    inputAttr: {},
    defaultValue: '',
    list: [],
    errorData: [],
    callback: null,
    onChange: null,
    onBlur: null,
    filter: (val) => {
      return val;
    },
  },
};
